import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";

import type { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";

import { folderUrlFromId } from "@dis/gapi";

@Component({
  selector: "folder-cell-renderer",
  imports: [MatIconModule],
  template: `
    @if (folderUrl) {
      <a
        [href]="folderUrl"
        target="_blank"
        rel="external noopener noreferrer"
        class="folder-link"
        (click)="$event.stopPropagation()"
      >
        <mat-icon aria-label="Folder icon">folder</mat-icon>
      </a>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
      }

      .folder-link {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
})
export class FolderCellRenderer implements ICellRendererAngularComp {
  public folderUrl: string = "";

  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  refresh(params: ICellRendererParams): boolean {
    const folderId = params.value;
    if (folderId) {
      this.folderUrl = folderUrlFromId(folderId);
    }
    return true;
  }
}
